import { render, staticRenderFns } from "./addNoteModal2.vue?vue&type=template&id=b4e333ec&scoped=true"
import script from "./addNoteModal2.vue?vue&type=script&lang=js"
export * from "./addNoteModal2.vue?vue&type=script&lang=js"
import style0 from "./addNoteModal2.vue?vue&type=style&index=0&id=b4e333ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e333ec",
  null
  
)

export default component.exports